import ai from './ai.svg';
import crm from './crm.svg';
import defaultIcon from './defaultIcon.svg';
import delayedPosting from './delayedPosting.svg';
import feedback from './feedback.svg';
import liking from './liking.svg';
import multiAccount from './multiaccount.svg';
import parsing from './parsing.svg';
import teams from './teams.svg';

export default {
  ai,
  crm,
  defaultIcon,
  delayedPosting,
  feedback,
  liking,
  multiAccount,
  parsing,
  teams,
};
